import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Comments } from '../models/comment.model';

@Injectable({
    providedIn: 'root',
})
export class CommentService {

    constructor(private _httpClient: HttpClient) { }

    /**
     * Add Comment
     */
    addComment(formData: Comments): Observable<Comments> {
        return this._httpClient
            .post<Comment>(environment.apiBaseUrl + '/comment/create', formData)
            .pipe(
                switchMap((response: any) => {
                    if (response.status === 200 || response.status === 201) {
                        return of(response);
                    } else {
                        return throwError(() => response);
                    }
                })
            );
    }

    /**
     * Get All Comments
     */
    getComments(): Observable<Comments[]> {
        return this._httpClient
            .get<Comments[]>(environment.apiBaseUrl + '/comment/get-all')
            .pipe(
                switchMap((response: any) => {
                    if (response.status === 200) {
                        return of(response.res); // based on your backend structure
                    } else {
                        return throwError(() => response);
                    }
                })
            );
    }

    /**
     * Get Single Comment
     */
    getCommentById(id: string): Observable<Comments> {
        return this._httpClient
            .get<Comments>(environment.apiBaseUrl + '/comment/' + id);
    }
}
